import { ReactElement, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';

import { FontSizes, FontWeights } from '../../utils/typography/types';
import Button from '../Button';
import Text from '../Text';
import { D2CTheme } from '../ThemeProvider';
import { ButtonWrapper, Copy, Wrapper } from './styles';
import { MarketingBannerProps } from './types';

const MarketingBanner = ({
	headingCopy,
	subheadingCopy,
	buttonCopy,
	isLoading = false,
	onPress,
	skipAnimation = false,
}: MarketingBannerProps): ReactElement => {
	const [isMounted, setIsMounted] = useState(skipAnimation);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsMounted(true);
		}, 50);

		return () => clearTimeout(timer);
	}, []);

	return (
		<ThemeProvider theme={D2CTheme}>
			<Wrapper $isMounted={isMounted}>
				<Copy>
					<Text noMargin el="h3" size={FontSizes.base} weight={FontWeights.Demi}>
						{headingCopy}
					</Text>
					<Text noMargin el="p" size={FontSizes.base}>
						{subheadingCopy}
					</Text>
				</Copy>
				<ButtonWrapper>
					<Button
						fullWidth
						maxWidth="192px"
						backgroundColor="white"
						textColor="blue2"
						loaderColor="blue2"
						onPress={onPress}
						isLoading={isLoading}
					>
						{buttonCopy}
					</Button>
				</ButtonWrapper>
			</Wrapper>
		</ThemeProvider>
	);
};

export default MarketingBanner;
